import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-surface" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-13">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-14">Про нас</h2>
            <p className="text-lg text-secondary leading-relaxed mb-6 font-medium text-primary" data-id="element-15">
              Ми спеціалізуємось виключно на реєстрації місця проживання у
              Києві. Без зайвих послуг — тільки те, що працює.
            </p>
            <p className="text-lg text-secondary leading-relaxed" data-id="element-16">
              За роки роботи ми оформили сотні прописок у різних районах Києва.
              Знаємо всі вимоги ЦНАПів, типові причини відмов і як їх уникнути.
              Працюємо офіційно, у межах закону — ви отримуєте реєстрацію, яка
              не викличе питань у жодного органу.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6" data-id="element-17">
            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-18">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-19">
                500+
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-20">
                Оформлених прописок у Києві
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-21">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-22">
                1 день
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-23">
                Середній термін оформлення
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-24">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-25">
                100%
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-26">
                Офіційно, у межах закону
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-27">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-28">
                Усі райони
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-29">
                Працюємо по всіх районах Києва
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}